import React from "react";
import {ReactComponent as Btt_radio} from "../../PatientTabs/assets/bttn_radio.svg";
import {ReactComponent as Btt_radio_esculab} from "../../PatientTabs/assets/bttn_radio_esculab.svg";
import {ReactComponent as Btt_complex} from "../images/complex.svg";
import {ReactComponent as Btt_delete} from "../images/bttn_delete.svg";
import icn_info from "../images/icn_info_red.svg";
import {isIncludedInComplexResearch, isIncludedInOrderingList} from "@cabinet-packages/helpers";
import {convertPrice} from "../../PatientTabs/helpers/convertPrice";
import AddRemoveButton from "./AddRemoveButton";
import AssayPopover from "../components/AssayPopover";
import {IconButton} from "@material-ui/core";
import {setSelectedTags} from "@cabinet-packages/redux";
import ComplexFillings from "./ComplexFillings";

export const RenderDuration = ({element}) => {
    const hours = Math.floor(element.duration_min / 60);
    const minutes = element.duration_min % 60;

    return <>
        {element.duration_day > 0 && `${element.duration_day} д`}
        {element.duration_min > 0 && <>
            {hours > 0 && <>
                <br/>
                {`${hours} год`}
            </>}
            {minutes > 0 && <>
                <br/>
                {`${minutes} хв`}
            </>}
        </>}
    </>
}

const RowRenderer = (props, filteredState, cl, complexResearch, orderingList, useSelectedTag, useCatalogForView, dispatch, usePrevState, selectedTags, catalogForViewTrue, isAdmin, actions) => {
    const { key, index, style } = props;
    const element = filteredState[index];
    const [catalogForView, setCatalogForView] = useCatalogForView;
    const [selectedTag, setSelectedTag] = useSelectedTag;
    const [prevStateOfCatalog, setPrevStateOfCatalog] = usePrevState;
    const isMedis = process.env.REACT_APP_CURRENT_CLINIC === "MEDIS";

    const handleGoToIncludedComplexes = (e) => {
        e.stopPropagation();
        e.preventDefault();

        if (!prevStateOfCatalog) {
            setPrevStateOfCatalog(({
                selectedTags,
                selectedTag,
                catalogForView: catalogForViewTrue
            }));

            const includedComplexes = complexResearch.reduce((acu, cur) => {
                if (cur && cur.filling && element.filling && !cur.notSale && cur.filling.find(fill => !!element.filling.find(itemFill => itemFill.id === fill.id))) {
                    return [...acu, cur];
                }
                if (element.id && cur.idGrTest && cur.idGrTest.find(grTest => +grTest.id === +element.id)) {
                    return [...acu, cur];
                }

                return acu;
            }, []);

            setCatalogForView([element, ...includedComplexes]);

            setSelectedTag('Усі');
            dispatch(setSelectedTags([]));
        } else {
            setSelectedTag(prevStateOfCatalog.selectedTag);
            dispatch(setSelectedTags(prevStateOfCatalog.selectedTags));
            setCatalogForView(prevStateOfCatalog.catalogForView);
            setPrevStateOfCatalog(null);
        }
    };



    return (<div className={cl.listItemWrapper} style={style} key={key+''+element.name}>
        <div className={cl.listItem} style={element.note || element.type === 'complex' ? {justifyContent: 'space-between'} : {}}>
            <div className={cl.listItemInnerWrapper} style={element.note || element.type === 'complex' ? {height: 'max-content', alignItems: 'center'} : {}}>
                <p className={cl.listItemName}>
                    <AssayPopover assay={element}/>
                </p>
                <div className={cl.listItemActionsWrapper}>
                    <div className={cl.listItemActions}>
                        <div className={
                            // cl.listItemActionsItemTerms
                            cl.listItemActionsItem
                        }>
                            {/*<RenderDuration element={element}/>*/}
                            {element.duration_day}
                        </div>
                        <div className={cl.listItemActionsItem}>
                            {complexResearch && isIncludedInComplexResearch(element, complexResearch)
                                ? <p className={cl.assayTerms}>
                                    <IconButton
                                        onClick={handleGoToIncludedComplexes}
                                        disabled={element.type === 'complex'}
                                    >
                                        {element.type === 'complex'
                                            ? <Btt_complex className={cl.btnComplex}/>
                                            : prevStateOfCatalog ? <Btt_delete className={cl.btnDelete}/> : isMedis ? <Btt_radio/> : <Btt_radio_esculab/>}
                                    </IconButton>
                                </p>
                                : <p className={cl.assayTerms}>-</p>
                            }
                        </div>
                        <div className={cl.listItemActionsItem}>
                            {convertPrice(element.price, 0, cl.listItemDiscountPrice)}
                        </div>
                        <div className={cl.listItemActionsItem}>
                            {(element.price == 0 && !(element.code.startsWith('Y') && isAdmin)) ? "Недоступно" : (
                                <AddRemoveButton item={element} isIncludedInOrderingList={isIncludedInOrderingList(element, orderingList)}/>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            {element.note && <div className={cl.listItemNote}>
                <img src={icn_info} alt="info icon." className={cl.listItemNoteImg}/><div dangerouslySetInnerHTML={{__html: element.note}} />
            </div>}
            {Array.isArray(element.filling) && <ComplexFillings element={element}/>}
        </div>
    </div>);
}

export default RowRenderer;
